import styled from 'styled-components'
import media from 'css-in-js-media'
import { Col } from 'react-styled-flexboxgrid'
import React from 'react'

const SectionStyled = styled.section`
    margin-top: 40px;
    margin-bottom: 40px;

    ${media('>=desktop')} {
        margin-top: 80px;
        margin-bottom: 80px;
    }

    ${Col} {
        ${media('<desktop')} {
            width: 100%;
        }
    }
`

const Section = ({ children, ...rest }) => {
    return (
        <>
            <SectionStyled {...rest}>{children}</SectionStyled>
        </>
    )
}

export default Section
